import React from "react";
import styled from "styled-components";
import { Plural } from "@lingui/macro";
import {
  Badge,
  BodyLarge,
  InsightsListOutline,
  spacing,
} from "@conserveit/blocks";
import { PriorityBadge } from "../PriorityBadge";
import { GroupHeadingProps } from "../../utils";
import {
  Bar,
  Left,
  Right,
  IconWrapper,
  TodayCountWrapper,
  SubduedBodyLarge,
} from "../GroupHeading.styles";

const PriorityBadgeWrapper = styled.div`
  display: inline-block;
  margin-right: ${spacing.tight};
  align-self: flex-start;
`;

const RuleGroupHeading: React.FunctionComponent<GroupHeadingProps> = ({
  instance,
  insightsCount,
  insightsCountToday,
  equipsCount,
  unassociatedEquipsCount,
}) => {
  return (
    <Bar>
      <Left>
        <IconWrapper>
          <InsightsListOutline />
        </IconWrapper>
        {instance.priority ? (
          <PriorityBadgeWrapper>
            <PriorityBadge priority={instance.priority} />
          </PriorityBadgeWrapper>
        ) : null}
        <BodyLarge as="div">
          {instance.ruleName}{" "}
          <SubduedBodyLarge as="span">({insightsCount})</SubduedBodyLarge>
          <TodayCountWrapper>
            <Plural
              value={equipsCount}
              one={`${unassociatedEquipsCount} of ${equipsCount} Equip Unassociated`}
              other={`${unassociatedEquipsCount} of ${equipsCount} Equips Unassociated`}
            />
          </TodayCountWrapper>
        </BodyLarge>
      </Left>
      <Right>
        {insightsCountToday > 0 && <Badge>{insightsCountToday} new</Badge>}
      </Right>
    </Bar>
  );
};

export default RuleGroupHeading;
